import { Utils } from "@/plugins/utils"
import router from "@/router"
import moment from "moment"

const toDateInput = value => (value ? String(value).substr(0, 10) : null)

const normalizeCalibration = calibration => ({
	...calibration,
	eqc: {
		...calibration.eqc,
		eqcdatac: toDateInput(calibration.eqc.eqcdatac),
		eqcdatav: toDateInput(calibration.eqc.eqcdatav),
	},
})

export default {
	namespaced: true,
	state: {
		lstEqc: [],
		calibration: null,
		insert: false,
		update: false,
		loading: false,
		since: "",
		until: moment().format("YYYY-MM-DD"),
		search: "",
		itemsPerPage: 20,
		hasNext: false,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getCalibration(state) {
			return { ...state.calibration }
		},
		getSearch(state) {
			return state.search
		},
	},
	mutations: {
		set(state, calibration) {
			state.calibration = calibration ? normalizeCalibration(calibration) : null
			state.insert = false
			state.update = !!calibration
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.calibration = null
		},
		setNew(state, calibration) {
			state.calibration = calibration
			state.insert = true
			state.update = false
		},
		setParamsDataTable(state, payload) {
			state.lstEqc = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setLstEqc(state, lstEqc) {
			state.lstEqc = lstEqc
		},
		setSearch(state, search) {
			state.search = search
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		add({ commit }) {
			commit("setNew", {
				eqc: {
					eqcid: 0,
					eqceqpid: 0,
					eqclotepdr: "",
					eqcobs: "",
					eqceqseq: 0,
					eqcdatac: moment().format("YYYY-MM-DD"),
					eqcdatav: null,
				},
				eqptag: "",
				eqpnome: "",
			})
		},
		async find({ commit, dispatch }, eqcid) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/OryxPlace/EquipmentCalibration/Find/${eqcid}`)
				.then(response => {
					const calibration = Utils.ValidateAxiosResponse(response.data)
					if (!calibration) throw new Error("Calibração não encontrada.")
					commit("set", calibration)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			const payload = await this._vm.$axios
				.post("/OryxPlace/EquipmentCalibration/Insert", getters.getCalibration.eqc)
				.then(response => {
					const calibration = Utils.ValidateAxiosResponse(response.data)
					commit("set", calibration)
					router.replace(`/oryxpdv/calibracao-equipamento/${calibration.eqc.eqcid}`)
					return calibration
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			const payload = await this._vm.$axios
				.put("/OryxPlace/EquipmentCalibration/Update", getters.getCalibration.eqc)
				.then(response => {
					const calibration = Utils.ValidateAxiosResponse(response.data)
					commit("set", calibration)
					return calibration
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/OryxPlace/EquipmentCalibration/Delete/${getters.getCalibration.eqc.eqcid}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/calibracoes-equipamentos")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findNextSequence({ dispatch }, eqpid) {
			return await this._vm.$axios
				.get(`/OryxPlace/EquipmentCalibration/FindNextSequence/${eqpid}`)
				.then(response => Utils.ValidateAxiosResponse(response.data))
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async findEquipments({ state, dispatch }) {
			const lstEqp = await dispatch("eqp/findActive", null, { root: true })
			const current = state.calibration
			if (current && current.eqc.eqceqpid && !lstEqp.some(eqp => eqp.eqpid == current.eqc.eqceqpid)) {
				lstEqp.push({ eqpid: current.eqc.eqceqpid, eqptag: current.eqptag, eqpnome: `${current.eqpnome} (inativo)` })
			}
			return lstEqp
		},
		async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")

			let url = `/OryxPlace/EquipmentCalibration/Search?search=${encodeURIComponent(getters.getSearch)}&limit=${limit}&page=${page}`
			if (state.since) {
				url += `&since=${state.since}`
			}
			if (state.until) {
				url += `&until=${state.until}`
			}

			const payload = await this._vm.$axios
				.get(url)
				.then(response => {
					commit("setParamsDataTable", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					commit("setLstEqc", [])
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
	},
}
